import axiosInstance from "./axiosInstance";

const getAllBadgeHistory = async ({ pageParam = 1 }) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const { data } = await axiosInstance.get(
      `/api/badge-history?page=${pageParam}&limit=10`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
    return {
      badgeHistory: data.badgeHistory,
      nextPage: pageParam + 1,
      totalPages: data.pagination.totalPages,
    };
  } catch (error) {
    throw new Error("Error fetching badge history.");
  }
};

export default getAllBadgeHistory;
